var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoppinsV19LatinRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Poppins",
    horizAdvX: 851
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Poppins",
    unitsPerEm: 1000,
    panose1: "0 0 5 0 0 0 0 0 0 0",
    ascent: 1050,
    descent: -350,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    glyphName: "space",
    horizAdvX: 267
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    glyphName: "exclam",
    horizAdvX: 298,
    d: "M195 697L184 197H108L97 697H195ZM124 -6T106 12T88 56Q88 82 106 100T150 118Q175 118 192 100T210 56Q210 30 193 12T150 -6Q124 -6 106 12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    glyphName: "quotedbl",
    horizAdvX: 292,
    d: "M121 796L110 597H47L35 796H121ZM256 796L245 597H182L170 796H256Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    glyphName: "numbersign",
    horizAdvX: 840,
    d: "M629 460L591 280H729V200H574L531 0H444L487 200H277L234 0H147L190 200H33V280H207L245 460H90V540H262L305 740H392L349 540H559L602 740H689L646 540H785V460H629ZM542 460H332L294 280H504L542 460Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    glyphName: "dollar",
    horizAdvX: 622,
    d: "M527 143T503 100T433 27T321 -6V-87H267V-6Q176 2 119 52T61 181H158Q162 139 189 108T267 69V319Q200 336 159 354T89 410T60 512Q60 593 116 646T267 705V788H321V705Q406 698 458 651T518 527H421Q416 562 390 590T321 628V384Q387 367 428 350T498 294T527 191Q527 143 503 100ZM153 468T182 442T267 399V630Q215 625 184 597T153 517Q153 468 182 442ZM375 74T405 107T436 186Q436 235 406 261T321 304V68Q375 74 405 107Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    glyphName: "percent",
    horizAdvX: 759,
    d: "M42 628T83 668T188 709Q252 709 293 669T334 560Q334 491 293 451T188 410Q124 410 83 450T42 560Q42 628 83 668ZM626 698L221 0H131L536 698H626ZM154 653T135 630T115 560Q115 514 134 490T188 466Q222 466 242 490T262 560Q262 606 242 629T188 653Q154 653 135 630ZM425 207T466 247T571 288Q635 288 675 248T716 138Q716 70 676 29T571 -12Q507 -12 466 28T425 138Q425 207 466 247ZM536 231T516 208T496 138Q496 93 516 70T570 46Q604 46 624 69T644 138Q644 184 624 207T570 231Q536 231 516 208Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    glyphName: "ampersand",
    horizAdvX: 739,
    d: "M612 0L521 92Q470 39 412 14T281 -12Q209 -12 154 14T68 88T37 200Q37 273 78 328T201 416Q169 454 155 486T141 556Q141 600 163 635T228 691T325 711Q379 711 419 690T479 632T497 548H406Q407 589 383 612T321 636Q281 636 257 614T232 556Q232 526 248 498T304 429L512 220L530 248L598 362H696L614 220Q597 190 574 157L731 0H612ZM335 66T378 87T461 152L256 358Q128 309 128 203Q128 144 170 105T281 66Q335 66 378 87Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    glyphName: "quotesingle",
    horizAdvX: 159,
    d: "M123 796L111 597H48L35 796H123Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    glyphName: "parenleft",
    horizAdvX: 454,
    d: "M215 -92T162 53T108 366Q108 538 164 687T326 934H421V925Q309 820 253 673T196 366Q196 211 249 70T406 -177V-186H311Q215 -92 162 53Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    glyphName: "parenright",
    horizAdvX: 454,
    d: "M48 -186V-177Q151 -71 204 70T258 366Q258 525 202 672T33 925V934H128Q233 837 289 688T346 366Q346 198 293 53T143 -186H48Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    glyphName: "asterisk",
    horizAdvX: 486,
    d: "M387 670L423 605L284 547L424 490L386 423L265 511L281 360H206L221 511L100 422L61 490L200 548L61 604L98 671L222 582L206 734H282L265 582L387 670Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    glyphName: "plus",
    horizAdvX: 683,
    d: "M597 327H384V111H299V327H87V404H299V621H384V404H597V327Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    glyphName: "comma",
    horizAdvX: 198,
    d: "M171 126L59 -143H-2L71 126H171Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    glyphName: "hyphen",
    horizAdvX: 551,
    d: "M713 405V328H314V405H713Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    glyphName: "period",
    horizAdvX: 210,
    d: "M80 -6T62 12T44 56Q44 82 62 100T106 118Q131 118 148 100T166 56Q166 30 149 12T106 -6Q80 -6 62 12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    glyphName: "slash",
    horizAdvX: 476,
    d: "M417 942L143 -170H53L326 942H417Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    glyphName: "zero",
    horizAdvX: 628,
    d: "M62 541T118 637T314 734Q453 734 509 638T565 369Q565 194 509 97T314 0Q174 0 118 97T62 369Q62 541 118 637ZM475 456T464 516T417 614T314 651Q246 651 211 614T164 517T152 369Q152 279 163 218T210 120T314 83Q381 83 416 120T463 218T475 369Q475 456 464 516Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    glyphName: "one",
    horizAdvX: 320,
    d: "M38 640V723H226V0H134V640H38Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    glyphName: "two",
    horizAdvX: 575,
    d: "M178 175T250 240T371 377T421 518Q421 583 390 620T288 658Q220 658 183 616T142 502H54Q58 614 122 675T287 736Q390 736 450 679T511 522Q511 439 462 361T349 223T188 84H532V8H51V73Q178 175 250 240Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    glyphName: "three",
    horizAdvX: 589,
    d: "M67 633T131 685T297 737Q365 737 414 713T489 646T515 551Q515 489 480 444T387 386V381Q452 365 490 318T528 195Q528 138 502 93T424 21T299 -5Q193 -5 125 50T49 208H137Q144 148 186 110T298 72Q368 72 404 108T441 203Q441 278 391 311T240 344H217V420H241Q333 421 380 450T427 542Q427 595 393 627T294 659Q232 659 194 627T149 541H60Q67 633 131 685Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    glyphName: "four",
    horizAdvX: 629,
    d: "M40 161V230L391 716H500V240H600V161H500V0H410V161H40ZM414 621L145 240H414V621Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    glyphName: "five",
    horizAdvX: 628,
    d: "M523 644H172V416Q195 448 240 468T337 489Q420 489 472 455T546 366T569 250Q569 178 542 121T460 31T322 -2Q217 -2 152 52T73 196H162Q175 139 217 107T323 75Q402 75 442 122T482 248Q482 326 442 368T324 411Q271 411 232 386T174 316H88V724H523V644Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    glyphName: "six",
    horizAdvX: 635,
    d: "M443 662T328 662Q239 662 195 594T152 368Q175 420 228 449T348 479Q451 479 512 415T574 238Q574 170 548 116T468 30T338 -2Q235 -2 177 44T96 171T73 371Q73 738 329 738Q427 738 483 685T549 551H465Q443 662 328 662ZM286 402T248 385T187 332T163 245Q163 169 207 122T333 74Q403 74 444 117T486 235Q486 313 446 357T329 402Q286 402 248 385Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    glyphName: "seven",
    horizAdvX: 546,
    d: "M507 652L229 0H137L419 643H33V721H507V652Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    glyphName: "eight",
    horizAdvX: 631,
    d: "M138 398T108 440T78 542Q78 596 105 639T185 708T315 734Q391 734 444 709T525 640T553 542Q553 484 522 441T437 376Q499 357 535 310T572 195Q572 130 540 82T450 7T315 -20Q239 -20 182 6T92 81T60 195Q60 262 96 310T194 376Q138 398 108 440ZM465 592T425 625T315 658Q246 658 206 625T166 530Q166 474 207 440T315 406Q382 406 423 440T465 531Q465 592 425 625ZM241 336T194 302T147 198Q147 134 192 95T315 56Q392 56 437 95T482 198Q482 265 436 300T315 336Q241 336 194 302Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    glyphName: "nine",
    horizAdvX: 630,
    d: "M189 137T225 106T324 75Q407 75 446 140T484 359Q463 314 414 289T305 263Q238 263 186 290T103 371T73 499Q73 606 135 671T311 737Q451 737 507 646T564 375Q564 249 542 167T466 42T319 -1Q217 -1 160 54T95 194H179Q189 137 225 106ZM387 340T430 381T473 494Q473 569 431 615T313 661Q243 661 202 617T160 501Q160 428 201 384T320 340Q387 340 430 381Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    glyphName: "colon",
    horizAdvX: 213,
    d: "M80 -6T62 12T44 56Q44 82 62 100T106 118Q131 118 148 100T166 56Q166 30 149 12T106 -6Q80 -6 62 12ZM80 422T62 440T44 484Q44 510 62 528T106 546Q131 546 148 528T166 484Q166 458 149 440T106 422Q80 422 62 440Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    glyphName: "semicolon",
    horizAdvX: 264,
    d: "M104 423T86 441T68 485Q68 511 86 529T130 547Q155 547 172 529T190 485Q190 459 173 441T130 423Q104 423 86 441ZM196 126L84 -143H23L96 126H196Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    glyphName: "less",
    horizAdvX: 555,
    d: "M325 136L84 366L325 595H440L198 366L440 136H325Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    glyphName: "equal",
    horizAdvX: 723,
    d: "M621 512V435H101V512H621ZM621 297V220H101V297H621Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    glyphName: "greater",
    horizAdvX: 539,
    d: "M94 595H209L451 366L209 136H94L336 366L94 595Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    glyphName: "question",
    horizAdvX: 524,
    d: "M354 706T415 650T476 500Q476 395 411 345T235 294L232 199H153L149 357H178Q277 357 333 387T389 500Q389 560 353 595T256 630Q194 630 159 597T123 505H37Q37 565 64 610T140 681T255 706Q354 706 415 650ZM166 -6T148 12T130 56Q130 82 148 100T192 118Q217 118 234 100T252 56Q252 30 235 12T192 -6Q166 -6 148 12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    glyphName: "at",
    horizAdvX: 1013,
    d: "M688 641T770 599T896 482T940 307Q940 228 914 156T839 38T723 -7Q673 -7 646 18T615 86Q584 43 537 18T436 -7Q360 -7 317 39T273 165Q273 240 304 305T392 409T519 449Q614 449 647 377L658 439H737L687 150Q684 131 684 115Q684 55 737 55Q777 55 806 93T851 188T866 302Q866 433 788 505T566 577Q447 577 352 520T202 362T148 141Q147 9 227 -62T449 -134Q543 -134 615 -100L627 -162Q538 -199 431 -199Q324 -199 243 -159T117 -43T72 133Q72 274 137 390T317 574T577 641Q688 641 770 599ZM508 64T546 90T606 162T628 262Q628 314 600 346T519 379Q471 379 435 351T378 276T358 179Q358 126 385 95T463 64Q508 64 546 90Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    glyphName: "A",
    horizAdvX: 674,
    d: "M489 155H185L129 0H33L285 693H390L641 0H545L489 155ZM463 229L337 581L211 229H463Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    glyphName: "B",
    horizAdvX: 613,
    d: "M464 353T495 328T545 266T564 187Q564 134 537 92T459 25T337 0H77V697H327Q398 697 448 674T523 610T548 520Q548 458 515 418T426 359Q464 353 495 328ZM168 396H321Q385 396 420 426T455 509Q455 562 420 592T319 622H168V396ZM397 75T435 107T473 196Q473 254 433 287T326 321H168V75H329Q397 75 435 107Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    glyphName: "C",
    horizAdvX: 772,
    d: "M43 451T89 532T214 660T391 706Q505 706 590 651T714 495H605Q576 558 522 592T391 626Q318 626 260 592T169 496T136 349Q136 266 169 204T260 107T391 73Q467 73 521 106T605 203H714Q675 103 590 49T391 -6Q294 -6 215 39T89 166T43 349Q43 451 89 532Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    glyphName: "D",
    horizAdvX: 707,
    d: "M408 697T491 655T619 533T664 347Q664 240 620 162T492 42T294 0H77V697H294Q408 697 491 655ZM429 75T500 146T571 347Q571 477 500 550T294 623H168V75H294Q429 75 500 146Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    glyphName: "E",
    horizAdvX: 513,
    d: "M168 623V390H422V315H168V75H452V0H77V698H452V623H168Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    glyphName: "F",
    horizAdvX: 504,
    d: "M471 697V623H168V388H414V314H168V0H77V697H471Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    glyphName: "G",
    horizAdvX: 778,
    d: "M605 495Q576 556 521 589T393 623Q320 623 262 590T170 494T136 349Q136 267 169 205T261 110T393 76Q495 76 561 137T638 302H360V376H735V306Q727 220 681 149T560 36T393 -6Q296 -6 216 39T90 166T43 349Q43 451 89 532T216 659T393 705Q504 705 589 650T714 495H605Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    glyphName: "H",
    horizAdvX: 692,
    d: "M614 697V0H523V316H168V0H77V697H168V391H523V697H614Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    glyphName: "I",
    horizAdvX: 246,
    d: "M168 697V0H77V697H168Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    glyphName: "J",
    horizAdvX: 530,
    d: "M428 697V182Q428 96 375 45T235 -7Q147 -7 94 45T41 189H132Q133 138 158 106T235 74Q286 74 311 104T336 182V697H428Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    glyphName: "K",
    horizAdvX: 599,
    d: "M455 0L168 318V0H77V697H168V374L456 697H571L255 348L574 0H455Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    glyphName: "L",
    horizAdvX: 432,
    d: "M168 74H412V0H77V697H168V74Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    glyphName: "M",
    horizAdvX: 861,
    d: "M784 692V0H693V516L463 0H399L168 517V0H77V692H175L431 120L687 692H784Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    glyphName: "N",
    horizAdvX: 703,
    d: "M625 0H534L168 555V0H77V698H168L534 144V698H625V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    glyphName: "O",
    horizAdvX: 786,
    d: "M296 -7T216 38T90 165T43 349Q43 451 89 532T216 659T393 705Q491 705 571 660T697 533T743 349Q743 246 697 165T571 39T393 -7Q296 -7 216 38ZM466 72T524 106T616 203T650 349Q650 433 617 495T525 592T393 626Q319 626 261 592T170 496T136 349Q136 266 169 203T261 106T393 72Q466 72 524 106Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    glyphName: "P",
    horizAdvX: 579,
    d: "M543 406T484 349T302 291H168V0H77V697H302Q420 697 481 640T543 493Q543 406 484 349ZM378 366T414 399T450 493Q450 622 302 622H168V366H302Q378 366 414 399Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    glyphName: "Q",
    horizAdvX: 788,
    d: "M636 -132L497 7Q446 -7 393 -7Q296 -7 216 38T90 165T43 349Q43 451 89 532T216 659T393 705Q491 705 571 660T697 533T743 349Q743 249 699 169T578 43L754 -132H636ZM136 266T169 203T261 106T393 72Q466 72 524 106T616 203T650 349Q650 433 617 495T525 592T393 626Q319 626 261 592T170 496T136 349Q136 266 169 203Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    glyphName: "R",
    horizAdvX: 608,
    d: "M444 0L278 285H168V0H77V697H302Q381 697 435 670T517 597T544 492Q544 420 503 365T378 292L553 0H444ZM168 358H302Q376 358 413 394T450 492Q450 554 414 588T302 622H168V358Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    glyphName: "S",
    horizAdvX: 587,
    d: "M229 -7T175 17T89 85T57 186H154Q159 137 194 104T298 70Q363 70 400 102T438 186Q438 226 416 251T361 289T272 317Q203 335 162 353T91 409T61 513Q61 570 90 614T171 682T292 706Q390 706 452 657T523 527H423Q418 567 381 597T283 628Q226 628 190 599T154 516Q154 478 175 454T228 418T317 389Q386 370 428 352T500 295T530 190Q530 139 503 94T423 21T298 -7Q229 -7 175 17Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    glyphName: "T",
    horizAdvX: 541,
    d: "M506 697V623H316V0H225V623H34V697H506Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    glyphName: "U",
    horizAdvX: 675,
    d: "M166 697V256Q166 163 211 118T338 73Q418 73 463 118T509 256V697H600V257Q600 170 565 111T471 22T337 -7Q263 -7 204 22T110 110T75 257V697H166Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    glyphName: "V",
    horizAdvX: 676,
    d: "M653 697L390 0H285L22 697H119L338 96L557 697H653Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    glyphName: "W",
    horizAdvX: 976,
    d: "M953 697L751 0H649L487 561L319 0L218 -1L23 697H120L272 106L440 697H542L702 108L855 697H953Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    glyphName: "X",
    horizAdvX: 621,
    d: "M362 348L576 0H473L306 272L147 0H46L259 348L45 697H147L315 424L475 697H577L362 348Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    glyphName: "Y",
    horizAdvX: 584,
    d: "M565 697L338 263V0H247V263L19 697H120L292 344L464 697H565Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    glyphName: "Z",
    horizAdvX: 541,
    d: "M154 79H494V0H46V72L384 618H50V697H492V625L154 79Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    glyphName: "bracketleft",
    horizAdvX: 423,
    d: "M313 934V859H218V-110H313V-186H133V934H313Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    glyphName: "backslash",
    horizAdvX: 658,
    d: "M444 -170L131 942H221L534 -170H444Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    glyphName: "bracketright",
    horizAdvX: 423,
    d: "M290 -186H110V-110H205V859H110V934H290V-186Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    glyphName: "asciicircum",
    horizAdvX: 629,
    d: "M131 169H37L272 693H357L593 169H498L316 581L131 169Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    glyphName: "underscore",
    horizAdvX: 733,
    d: "M637 -38V-122H105V-38H637Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    glyphName: "grave",
    horizAdvX: 257,
    d: "M230 657V589L17 703V782L230 657Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    glyphName: "a",
    horizAdvX: 676,
    d: "M43 360T77 423T170 522T303 557Q375 557 428 526T507 448V548H599V0H507V102Q480 54 427 23T302 -9Q229 -9 170 27T77 128T43 276Q43 360 77 423ZM507 337T482 383T415 453T321 478Q270 478 228 454T161 384T136 276Q136 213 161 167T228 96T321 71Q372 71 414 95T482 166T507 275Q507 337 482 383Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    glyphName: "b",
    horizAdvX: 676,
    d: "M196 495T250 526T373 557Q447 557 506 522T599 424T633 276Q633 193 599 128T506 27T373 -9Q302 -9 249 22T168 101V0H77V740H168V446Q196 495 250 526ZM540 338T515 384T448 454T354 478Q304 478 262 454T194 383T168 275Q168 213 193 167T261 96T354 71Q405 71 447 95T515 166T540 276Q540 338 515 384Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    glyphName: "c",
    horizAdvX: 607,
    d: "M43 360T77 423T171 522T310 557Q411 557 476 508T563 372H465Q451 422 411 451T310 480Q232 480 184 427T136 275Q136 176 184 122T310 68Q370 68 410 96T465 176H563Q541 92 475 42T310 -9Q232 -9 172 26T77 125T43 275Q43 360 77 423Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    glyphName: "d",
    horizAdvX: 676,
    d: "M43 360T77 423T170 522T304 557Q368 557 423 528T507 450V740H599V0H507V103Q480 54 427 23T303 -9Q230 -9 171 27T77 128T43 276Q43 360 77 423ZM507 337T482 383T415 453T321 478Q270 478 228 454T161 384T136 276Q136 213 161 167T228 96T321 71Q372 71 414 95T482 166T507 275Q507 337 482 383Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    glyphName: "e",
    horizAdvX: 620,
    d: "M577 269T574 240H136Q141 159 191 114T314 68Q373 68 412 95T468 169H566Q544 90 478 41T314 -9Q236 -9 175 26T78 125T43 275Q43 360 77 424T172 522T314 557Q392 557 452 523T544 430T577 295Q577 269 574 240ZM483 366T460 403T398 460T310 480Q241 480 193 436T137 314H483Q483 366 460 403Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    glyphName: "f",
    horizAdvX: 329,
    d: "M300 473H185V0H94V473H23V548H94V587Q94 679 141 721T294 764V688Q234 688 210 665T185 587V548H300V473Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    glyphName: "g",
    horizAdvX: 676,
    d: "M374 557T427 526T507 448V548H599V-12Q599 -87 567 -145T476 -237T337 -270Q229 -270 157 -219T72 -80H162Q177 -130 224 -160T337 -191Q412 -191 459 -144T507 -12V103Q480 55 427 23T303 -9Q230 -9 171 27T77 128T43 276Q43 360 77 423T170 522T303 557Q374 557 427 526ZM507 337T482 383T415 453T321 478Q270 478 228 454T161 384T136 276Q136 213 161 167T228 96T321 71Q372 71 414 95T482 166T507 275Q507 337 482 383Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    glyphName: "h",
    horizAdvX: 640,
    d: "M411 558T461 532T539 452T568 323V0H478V310Q478 392 437 435T325 479Q253 479 211 434T168 303V0H77V740H168V470Q195 512 242 535T349 558Q411 558 461 532Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    glyphName: "i",
    horizAdvX: 246,
    d: "M98 637T80 655T62 699Q62 725 80 743T124 761Q149 761 166 743T184 699Q184 673 167 655T124 637Q98 637 80 655ZM168 548V0H77V548H168Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    glyphName: "j",
    horizAdvX: 248,
    d: "M100 637T83 655T65 699Q65 725 82 743T126 761Q152 761 169 743T187 699Q187 673 170 655T126 637Q100 637 83 655ZM171 -119Q171 -192 134 -226T26 -260H-27V-183H11Q49 -183 64 -168T80 -117V548H171V-119Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    glyphName: "k",
    horizAdvX: 515,
    d: "M383 0L168 242V0H77V740H168V305L379 548H506L248 275L507 0H383Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    glyphName: "l",
    horizAdvX: 246,
    d: "M168 740V0H77V740H168Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    glyphName: "m",
    horizAdvX: 1030,
    d: "M800 558T850 532T929 452T958 323V0H868V310Q868 392 828 435T718 479Q647 479 605 434T563 302V0H473V310Q473 392 433 435T323 479Q252 479 210 434T168 302V0H77V548H168V469Q195 512 240 535T341 558Q410 558 463 527T542 436Q565 494 618 526T736 558Q800 558 850 532Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    glyphName: "n",
    horizAdvX: 640,
    d: "M444 558T506 498T568 323V0H478V310Q478 392 437 435T325 479Q253 479 211 434T168 303V0H77V548H168V470Q195 512 241 535T344 558Q444 558 506 498Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    glyphName: "o",
    horizAdvX: 640,
    d: "M239 -9T177 26T79 125T43 275Q43 359 79 423T179 522T320 557Q398 557 461 523T560 424T597 275Q597 190 560 126T458 26T316 -9Q239 -9 177 26ZM365 71T408 94T477 163T504 275Q504 341 478 387T410 455T319 478Q269 478 228 456T161 387T136 275Q136 208 160 162T226 94T316 71Q365 71 408 94Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    glyphName: "p",
    horizAdvX: 676,
    d: "M195 494T248 525T373 557Q446 557 505 522T599 424T633 276Q633 193 599 128T506 27T373 -9Q303 -9 250 22T168 101V-260H77V548H168V447Q195 494 248 525ZM540 338T515 384T448 454T354 478Q304 478 262 454T194 383T168 275Q168 213 193 167T261 96T354 71Q405 71 447 95T515 166T540 276Q540 338 515 384Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    glyphName: "q",
    horizAdvX: 676,
    d: "M43 360T77 423T170 522T304 557Q375 557 428 526T507 448V548H599V-260H507V101Q481 55 427 23T301 -9Q229 -9 170 27T77 128T43 276Q43 360 77 423ZM507 337T482 383T415 453T321 478Q270 478 228 454T161 384T136 276Q136 213 161 167T228 96T321 71Q372 71 414 95T482 166T507 275Q507 337 482 383Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    glyphName: "r",
    horizAdvX: 373,
    d: "M192 506T236 532T345 558V464H321Q168 464 168 298V0H77V548H168V459Q192 506 236 532Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    glyphName: "s",
    horizAdvX: 522,
    d: "M208 -9T158 12T79 72T47 161H141Q145 120 179 94T270 68Q322 68 352 91T382 149Q382 185 350 202T251 237Q190 253 152 269T86 318T58 404Q58 446 83 481T154 536T259 557Q350 557 406 511T466 385H375Q372 428 341 454T256 480Q207 480 178 459T149 404Q149 377 166 360T210 332T284 308Q343 292 380 277T443 230T471 149Q471 104 446 68T376 12T271 -9Q208 -9 158 12Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    glyphName: "t",
    horizAdvX: 364,
    d: "M188 473V150Q188 110 205 94T264 77H331V0H249Q173 0 135 35T97 150V473H26V548H97V686H188V548H331V473H188Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    glyphName: "u",
    horizAdvX: 640,
    d: "M563 548V0H472V81Q446 39 400 16T297 -8Q233 -8 182 18T102 98T72 227V548H162V239Q162 158 203 115T315 71Q388 71 430 116T472 247V548H563Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    glyphName: "v",
    horizAdvX: 561,
    d: "M281 84L451 548H548L333 0H227L12 548H110L281 84Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    glyphName: "w",
    horizAdvX: 820,
    d: "M807 548L636 0H542L410 435L278 0H184L12 548H105L231 88L367 548H460L593 87L717 548H807Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    glyphName: "x",
    horizAdvX: 479,
    d: "M363 0L233 204L108 0H13L190 272L13 548H116L246 345L370 548H465L289 277L466 0H363Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    glyphName: "y",
    horizAdvX: 563,
    d: "M549 548L219 -258H125L233 6L12 548H113L285 104L455 548H549Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    glyphName: "z",
    horizAdvX: 455,
    d: "M145 75H414V0H41V75L307 474H43V548H412V474L145 75Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    glyphName: "braceleft",
    horizAdvX: 462,
    d: "M105 409Q207 428 207 514Q207 552 197 644Q187 742 187 786Q187 858 227 896T336 934H394V855H353Q314 855 295 838T276 780Q276 751 280 709T285 651Q295 555 295 511Q295 458 269 423T187 375V373Q242 361 268 325T295 236Q295 192 285 96Q284 81 280 39T276 -33Q276 -73 295 -90T353 -108H394V-187H336Q268 -187 228 -149T187 -39Q187 5 197 103Q207 195 207 233Q207 319 105 338V409Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    glyphName: "bar",
    horizAdvX: 291,
    d: "M191 -106H100V795H191V-106Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    glyphName: "braceright",
    horizAdvX: 462,
    d: "M255 319T255 233Q255 195 265 103Q275 5 275 -39Q275 -111 235 -149T126 -187H68V-108H109Q148 -108 167 -91T186 -33Q186 -4 182 38T177 96Q167 192 167 236Q167 289 193 325T275 373V375Q220 387 194 422T167 511Q167 555 177 651Q178 666 182 708T186 780Q186 820 167 837T109 855H68V934H126Q194 934 234 896T275 786Q275 742 265 644Q255 552 255 514Q255 428 357 409V338Q255 319 255 233Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    glyphName: "asciitilde",
    horizAdvX: 519,
    d: "M63 394T178 394Q205 394 226 385T275 357Q299 342 314 335T347 328Q373 328 391 345T414 393H482Q457 247 340 247Q314 247 294 256T245 283Q221 298 206 305T172 313Q146 313 127 296T104 248H37Q63 394 178 394Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    glyphName: "uni00A0",
    horizAdvX: 267
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    glyphName: "exclamdown",
    horizAdvX: 298,
    d: "M175 564T192 546T210 502Q210 476 193 458T150 440Q124 440 106 458T88 502Q88 528 106 546T150 564Q175 564 192 546ZM108 361H184L195 -139H97L108 361Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    glyphName: "cent",
    horizAdvX: 665,
    d: "M383 80T421 107T471 184H556Q547 110 491 61T347 5V-89H293V5Q185 14 125 84T65 262Q65 369 125 439T293 519V611H347V519Q434 512 490 463T556 341H471Q459 389 421 417T322 445Q246 445 199 397T151 262Q151 176 198 128T322 80Q383 80 421 107Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    glyphName: "sterling",
    horizAdvX: 620,
    d: "M545 74V-2H99L83 50Q125 97 145 140T166 246Q166 272 157 308H44V372H135Q122 407 115 438T108 508Q108 572 135 619T212 693T326 719Q428 719 483 660T542 511H458Q456 570 423 606T326 642Q268 642 232 608T195 504Q195 471 202 442T223 372H417V308H243Q252 272 252 246Q252 151 181 74H545Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    glyphName: "currency",
    horizAdvX: 537,
    d: "M446 317T414 271L473 212L432 170L372 230Q325 200 267 200Q207 200 164 229L105 170L63 212L122 271Q92 317 92 377Q92 439 124 484L63 544L105 586L166 525Q209 554 268 554Q327 554 371 525L432 586L473 544L413 484Q446 440 446 377Q446 317 414 271ZM309 259T339 290T369 377Q369 432 340 464T267 496Q225 496 197 465T168 377Q168 321 196 290T267 259Q309 259 339 290Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    glyphName: "yen",
    horizAdvX: 595,
    d: "M407 383H544V317L371 315L344 263V224H544V157H344V0H253V157H53V224H253V263L225 315L53 317V383H190L25 697H127L298 345L469 697H571L407 383Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    glyphName: "brokenbar",
    horizAdvX: 291,
    d: "M100 795H191V417H100V795ZM191 -106H100V273H191V-106Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    glyphName: "section",
    horizAdvX: 575,
    d: "M442 72T470 40T499 -39Q499 -82 475 -118T404 -175T295 -196Q203 -196 145 -153T84 -31H175Q179 -76 208 -104T295 -132Q349 -132 378 -111T408 -46Q408 -21 394 -3T345 32T247 70Q145 104 96 146T46 258Q46 314 81 357T184 420Q133 445 105 476T76 555Q76 598 100 634T171 691T281 712Q373 712 431 668T491 546H400Q397 590 368 618T281 647Q227 647 197 626T167 563Q167 537 181 519T230 483T328 445Q429 412 479 370T529 258Q529 202 494 159T391 95Q442 72 470 40ZM139 209T180 176T290 143Q357 143 396 176T436 258Q436 308 395 340T286 372Q218 372 179 339T139 258Q139 209 180 176Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    glyphName: "dieresis",
    horizAdvX: 314,
    d: "M54 622T39 637T23 674Q23 696 38 711T76 727Q97 727 112 712T128 674Q128 652 113 637T76 622Q54 622 39 637ZM216 622T201 637T186 674Q186 696 201 711T238 727Q260 727 275 712T291 674Q291 652 276 637T238 622Q216 622 201 637Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    glyphName: "copyright",
    horizAdvX: 792,
    d: "M498 704T577 659T699 533T743 349Q743 246 700 166T577 40T397 -6Q295 -6 216 39T93 165T49 349Q49 452 93 532T216 658T397 704Q498 704 577 659ZM304 664T235 625T129 514T92 349Q92 256 129 185T235 73T397 33Q489 33 557 73T663 184T700 349Q700 443 663 514T558 624T397 664Q304 664 235 625ZM335 581T286 553T207 473T178 350Q178 280 207 228T285 147T395 118Q470 118 525 158T600 267H516Q486 184 395 184Q335 184 297 227T259 349Q259 429 297 472T395 515Q439 515 471 494T516 432H600Q581 503 526 542T395 581Q335 581 286 553Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    glyphName: "ordfeminine",
    horizAdvX: 450,
    d: "M33 582T55 623T115 686T200 709Q247 709 280 691T331 642V703H403V353H331V413Q315 384 282 366T202 347Q154 347 116 370T55 435T33 530Q33 582 55 623ZM108 472T140 438T219 404Q267 404 299 437T331 528Q331 585 299 618T219 652Q172 652 140 619T108 529Q108 472 140 438Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    glyphName: "guillemotleft",
    horizAdvX: 461,
    d: "M141 120L45 295L141 470H230L131 295L230 120H141ZM321 120L226 295L321 470H411L312 295L411 120H321Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    glyphName: "logicalnot",
    horizAdvX: 650,
    d: "M606 432V220H515V360H41V432H606Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    glyphName: "uni00AD",
    horizAdvX: 551,
    d: "M713 405V328H314V405H713Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    glyphName: "registered",
    horizAdvX: 509,
    d: "M313 706T359 680T431 607T457 502Q457 444 431 397T359 324T255 297Q196 297 150 323T78 397T52 502Q52 560 78 606T150 679T255 706Q313 706 359 680ZM327 337T371 383T416 502Q416 575 372 621T255 667Q182 667 139 621T95 502Q95 429 138 383T255 337Q327 337 371 383ZM345 520T333 504T298 480L354 397L291 396L243 476H226V396H174V611H270Q304 611 324 593T345 544Q345 520 333 504ZM226 519H267Q278 519 285 525T293 542Q293 553 286 558T267 564H226V519Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    glyphName: "overscore",
    horizAdvX: 387,
    d: "M369 709V641H17V709H369Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    glyphName: "degree",
    horizAdvX: 410,
    d: "M28 603T77 651T205 699Q283 699 332 651T381 524Q381 471 358 431T295 369T203 347Q125 347 77 395T28 524Q28 603 77 651ZM308 581T279 613T204 646Q160 646 131 614T101 524Q101 465 129 434T203 402Q248 402 278 434T308 524Q308 581 279 613Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    glyphName: "plusminus",
    horizAdvX: 686,
    d: "M386 377V195H597V118H88V195H301V377H88V454H301V624H386V454H597V377H386Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    glyphName: "twosuperior",
    horizAdvX: 330,
    d: "M289 411V352H32V404L141 492Q174 519 191 543T209 597Q209 624 195 639T157 654Q133 654 120 641T103 603H30Q32 650 66 680T159 710Q216 710 250 678T285 600Q285 562 263 533T192 467L113 411H289Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    glyphName: "threesuperior",
    horizAdvX: 332,
    d: "M32 655T68 682T163 710Q219 710 257 680T295 607Q295 577 278 557T233 529V527Q261 517 279 496T298 444Q298 403 260 375T160 347Q100 347 64 375T23 454H95Q99 427 115 414T159 401Q187 401 203 415T220 453Q220 477 203 491T157 505H114V553H155Q184 553 201 566T218 603Q218 626 202 640T158 655Q132 655 117 643T96 611H27Q32 655 68 682Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    glyphName: "acute",
    horizAdvX: 247,
    d: "M230 703L17 589V657L230 782V703Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB5",
    glyphName: "uni00B5",
    horizAdvX: 645,
    d: "M568 548V0H477V100Q451 46 404 19T295 -9Q255 -9 222 6T167 54V-260H77V548H167V248Q167 161 209 115T323 69Q394 69 435 114T477 245V548H568Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    glyphName: "paragraph",
    horizAdvX: 596,
    d: "M518 0H437V621H360V0H279V286H268Q151 286 91 342T31 488Q31 578 91 635T268 692H518V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    glyphName: "middot",
    horizAdvX: 212,
    d: "M83 279T65 297T47 341Q47 367 65 385T109 403Q134 403 151 385T169 341Q169 315 152 297T109 279Q83 279 65 297Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    glyphName: "cedilla",
    horizAdvX: 272,
    d: "M184 -57T219 -83T254 -157Q254 -204 220 -232T132 -260H17V-201H114Q147 -201 162 -191T178 -157Q178 -134 163 -124T114 -114H64V7H125V-58Q184 -57 219 -83Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    glyphName: "onesuperior",
    horizAdvX: 196,
    d: "M25 648V704H151V352H79V648H25Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    glyphName: "ordmasculine",
    horizAdvX: 436,
    d: "M33 582T57 623T123 686T218 709Q271 709 313 687T379 623T403 528Q403 475 379 434T312 369T217 346Q164 346 123 369T57 433T33 528Q33 582 57 623ZM329 586T297 619T218 652Q171 652 140 619T108 527Q108 469 139 437T217 404Q263 404 296 437T329 527Q329 586 297 619Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    glyphName: "guillemotright",
    horizAdvX: 461,
    d: "M149 295L50 470H139L235 295L139 120H50L149 295ZM329 295L231 470H320L416 295L320 120H231L329 295Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    glyphName: "onequarter",
    horizAdvX: 640,
    d: "M38 648V704H164V352H92V648H38ZM522 698L148 0H62L436 698H522ZM604 69H556V0H484V69H301V111L459 353H556V116H604V69ZM486 291L375 116H486V291Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    glyphName: "onehalf",
    horizAdvX: 675,
    d: "M90 648H36V704H162V352H90V648ZM509 698L144 0H57L423 698H509ZM627 58V-1H370V51L479 139Q512 166 529 190T547 244Q547 271 533 286T495 301Q471 301 458 288T441 250H368Q370 297 404 327T497 357Q554 357 588 325T623 247Q623 209 601 180T530 114L451 58H627Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    glyphName: "threequarters",
    horizAdvX: 709,
    d: "M44 655T80 682T175 710Q231 710 269 680T307 607Q307 577 290 557T245 529V527Q273 517 291 496T310 444Q310 403 272 375T172 347Q112 347 76 375T35 454H107Q111 427 127 414T171 401Q199 401 215 415T232 453Q232 477 215 491T169 505H126V553H167Q196 553 213 566T230 603Q230 626 214 640T170 655Q144 655 129 643T108 611H39Q44 655 80 682ZM617 698L228 0H143L531 698H617ZM682 69H635V0H563V69H380V111L538 353H635V116H682V69ZM564 291L453 116H564V291Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    glyphName: "questiondown",
    horizAdvX: 519,
    d: "M356 556T374 538T392 494Q392 468 374 450T330 432Q305 432 288 450T270 494Q270 520 287 538T330 556Q356 556 374 538ZM168 -156T107 -100T46 50Q46 155 111 205T287 256L290 351H369L373 193H344Q245 193 189 163T133 50Q133 -10 169 -45T266 -80Q328 -80 363 -47T399 45H485Q485 -15 458 -60T382 -131T267 -156Q168 -156 107 -100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    glyphName: "Agrave",
    horizAdvX: 674,
    d: "M489 155H185L129 0H33L285 693H390L641 0H545L489 155ZM463 229L337 581L211 229H463ZM435 802V734L222 848V927L435 802Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    glyphName: "Aacute",
    horizAdvX: 674,
    d: "M489 155H185L129 0H33L285 693H390L641 0H545L489 155ZM463 229L337 581L211 229H463ZM435 848L222 734V802L435 927V848Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    glyphName: "Acircumflex",
    horizAdvX: 674,
    d: "M489 155H185L129 0H33L285 693H390L641 0H545L489 155ZM463 229L337 581L211 229H463ZM338 827L199 742V814L338 897L476 814V742L338 827Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    glyphName: "Atilde",
    horizAdvX: 674,
    d: "M489 155H185L129 0H33L285 693H390L641 0H545L489 155ZM463 229L337 581L211 229H463ZM197 803T223 830T290 857Q309 857 322 851T355 832Q369 822 380 817T404 811Q421 811 433 822T448 854H500Q494 804 467 777T400 750Q381 750 367 756T334 776Q318 786 309 791T286 796Q269 796 258 785T243 752H190Q197 803 223 830Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    glyphName: "Adieresis",
    horizAdvX: 674,
    d: "M489 155H185L129 0H33L285 693H390L641 0H545L489 155ZM463 229L337 581L211 229H463ZM235 767T220 782T204 819Q204 841 219 856T257 872Q278 872 293 857T309 819Q309 797 294 782T257 767Q235 767 220 782ZM397 767T382 782T367 819Q367 841 382 856T419 872Q441 872 456 857T472 819Q472 797 457 782T419 767Q397 767 382 782Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    glyphName: "Aring",
    horizAdvX: 674,
    d: "M489 155H185L129 0H33L285 693H390L641 0H545L489 155ZM463 229L337 581L211 229H463ZM445 809T415 781T338 752Q293 752 262 781T231 857Q231 904 262 933T338 962Q384 962 414 934T445 857Q445 809 415 781ZM392 883T377 898T338 914Q315 914 300 899T284 858Q284 833 299 817T338 801Q361 801 376 817T392 858Q392 883 377 898Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    glyphName: "AE",
    horizAdvX: 900,
    d: "M556 626V387H808V317H556V72H838V0H465V155H198L111 0H12L407 698H838V626H556ZM465 226V629L238 226H465Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    glyphName: "Ccedilla",
    horizAdvX: 772,
    d: "M467 73T521 106T605 203H714Q678 111 603 57T426 -5V-58Q485 -57 520 -83T555 -157Q555 -204 521 -232T433 -260H318V-201H415Q448 -201 463 -191T479 -157Q479 -134 464 -124T415 -114H365V-5Q274 1 201 47T85 172T43 349Q43 451 89 532T214 660T391 706Q505 706 590 651T714 495H605Q576 558 522 592T391 626Q318 626 260 592T169 496T136 349Q136 266 169 204T260 107T391 73Q467 73 521 106Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    glyphName: "Egrave",
    horizAdvX: 513,
    d: "M168 623V390H422V315H168V75H452V0H77V698H452V623H168ZM352 802V734L139 848V927L352 802Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    glyphName: "Eacute",
    horizAdvX: 513,
    d: "M168 623V390H422V315H168V75H452V0H77V698H452V623H168ZM352 848L139 734V802L352 927V848Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    glyphName: "Ecircumflex",
    horizAdvX: 513,
    d: "M168 623V390H422V315H168V75H452V0H77V698H452V623H168ZM255 827L116 742V814L255 897L393 814V742L255 827Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    glyphName: "Edieresis",
    horizAdvX: 513,
    d: "M168 623V390H422V315H168V75H452V0H77V698H452V623H168ZM152 767T137 782T121 819Q121 841 136 856T174 872Q195 872 210 857T226 819Q226 797 211 782T174 767Q152 767 137 782ZM314 767T299 782T284 819Q284 841 299 856T336 872Q358 872 373 857T389 819Q389 797 374 782T336 767Q314 767 299 782Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    glyphName: "Igrave",
    horizAdvX: 246,
    d: "M168 697V0H77V697H168ZM220 802V734L7 848V927L220 802Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    glyphName: "Iacute",
    horizAdvX: 246,
    d: "M168 697V0H77V697H168ZM220 848L7 734V802L220 927V848Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    glyphName: "Icircumflex",
    horizAdvX: 246,
    d: "M168 697V0H77V697H168ZM123 827L-16 742V814L123 897L261 814V742L123 827Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    glyphName: "Idieresis",
    horizAdvX: 246,
    d: "M168 697V0H77V697H168ZM20 767T5 782T-11 819Q-11 841 4 856T42 872Q63 872 78 857T94 819Q94 797 79 782T42 767Q20 767 5 782ZM182 767T167 782T152 819Q152 841 167 856T204 872Q226 872 241 857T257 819Q257 797 242 782T204 767Q182 767 167 782Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    glyphName: "Eth",
    horizAdvX: 725,
    d: "M426 697T509 655T637 533T682 347Q682 240 638 162T510 42T313 0H96V305H9V389H96V697H313Q426 697 509 655ZM447 70T518 143T589 347Q589 477 518 550T313 623H187V389H379V305H187V70H313Q447 70 518 143Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    glyphName: "Ntilde",
    horizAdvX: 703,
    d: "M625 0H534L168 555V0H77V698H168L534 144V698H625V0ZM212 803T238 830T305 857Q324 857 337 851T370 832Q384 822 395 817T419 811Q436 811 448 822T463 854H515Q509 804 482 777T415 750Q396 750 382 756T349 776Q333 786 324 791T301 796Q284 796 273 785T258 752H205Q212 803 238 830Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    glyphName: "Ograve",
    horizAdvX: 786,
    d: "M296 -7T216 38T90 165T43 349Q43 451 89 532T216 659T393 705Q491 705 571 660T697 533T743 349Q743 246 697 165T571 39T393 -7Q296 -7 216 38ZM466 72T524 106T616 203T650 349Q650 433 617 495T525 592T393 626Q319 626 261 592T170 496T136 349Q136 266 169 203T261 106T393 72Q466 72 524 106ZM493 802V734L280 848V927L493 802Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    glyphName: "Oacute",
    horizAdvX: 786,
    d: "M296 -7T216 38T90 165T43 349Q43 451 89 532T216 659T393 705Q491 705 571 660T697 533T743 349Q743 246 697 165T571 39T393 -7Q296 -7 216 38ZM466 72T524 106T616 203T650 349Q650 433 617 495T525 592T393 626Q319 626 261 592T170 496T136 349Q136 266 169 203T261 106T393 72Q466 72 524 106ZM493 848L280 734V802L493 927V848Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    glyphName: "Ocircumflex",
    horizAdvX: 786,
    d: "M296 -7T216 38T90 165T43 349Q43 451 89 532T216 659T393 705Q491 705 571 660T697 533T743 349Q743 246 697 165T571 39T393 -7Q296 -7 216 38ZM466 72T524 106T616 203T650 349Q650 433 617 495T525 592T393 626Q319 626 261 592T170 496T136 349Q136 266 169 203T261 106T393 72Q466 72 524 106ZM396 827L257 742V814L396 897L534 814V742L396 827Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    glyphName: "Otilde",
    horizAdvX: 786,
    d: "M296 -7T216 38T90 165T43 349Q43 451 89 532T216 659T393 705Q491 705 571 660T697 533T743 349Q743 246 697 165T571 39T393 -7Q296 -7 216 38ZM466 72T524 106T616 203T650 349Q650 433 617 495T525 592T393 626Q319 626 261 592T170 496T136 349Q136 266 169 203T261 106T393 72Q466 72 524 106ZM256 803T282 830T349 857Q368 857 381 851T414 832Q428 822 439 817T463 811Q480 811 492 822T507 854H559Q553 804 526 777T459 750Q440 750 426 756T393 776Q377 786 368 791T345 796Q328 796 317 785T302 752H249Q256 803 282 830Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    glyphName: "Odieresis",
    horizAdvX: 786,
    d: "M296 -7T216 38T90 165T43 349Q43 451 89 532T216 659T393 705Q491 705 571 660T697 533T743 349Q743 246 697 165T571 39T393 -7Q296 -7 216 38ZM466 72T524 106T616 203T650 349Q650 433 617 495T525 592T393 626Q319 626 261 592T170 496T136 349Q136 266 169 203T261 106T393 72Q466 72 524 106ZM293 767T278 782T262 819Q262 841 277 856T315 872Q336 872 351 857T367 819Q367 797 352 782T315 767Q293 767 278 782ZM455 767T440 782T425 819Q425 841 440 856T477 872Q499 872 514 857T530 819Q530 797 515 782T477 767Q455 767 440 782Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    glyphName: "multiply",
    horizAdvX: 643,
    d: "M481 150L322 309L163 150L103 210L262 369L106 525L164 584L321 427L478 584L538 524L381 367L539 208L481 150Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    glyphName: "Oslash",
    horizAdvX: 786,
    d: "M654 593Q697 546 720 484T743 349Q743 246 697 165T571 39T393 -7Q330 -7 274 12T172 68L109 0H35L132 106Q90 154 67 216T43 349Q43 451 89 532T216 659T393 705Q456 705 512 686T614 630L677 698H751L654 593ZM136 241T191 169L558 569Q490 626 393 626Q319 626 261 592T170 496T136 349Q136 241 191 169ZM650 456T596 529L228 129Q296 72 393 72Q466 72 524 106T616 203T650 349Q650 456 596 529Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    glyphName: "Ugrave",
    horizAdvX: 675,
    d: "M166 697V256Q166 163 211 118T338 73Q418 73 463 118T509 256V697H600V257Q600 170 565 111T471 22T337 -7Q263 -7 204 22T110 110T75 257V697H166ZM435 802V734L222 848V927L435 802Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    glyphName: "Uacute",
    horizAdvX: 675,
    d: "M166 697V256Q166 163 211 118T338 73Q418 73 463 118T509 256V697H600V257Q600 170 565 111T471 22T337 -7Q263 -7 204 22T110 110T75 257V697H166ZM435 848L222 734V802L435 927V848Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    glyphName: "Ucircumflex",
    horizAdvX: 675,
    d: "M166 697V256Q166 163 211 118T338 73Q418 73 463 118T509 256V697H600V257Q600 170 565 111T471 22T337 -7Q263 -7 204 22T110 110T75 257V697H166ZM338 827L199 742V814L338 897L476 814V742L338 827Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    glyphName: "Udieresis",
    horizAdvX: 675,
    d: "M166 697V256Q166 163 211 118T338 73Q418 73 463 118T509 256V697H600V257Q600 170 565 111T471 22T337 -7Q263 -7 204 22T110 110T75 257V697H166ZM235 767T220 782T204 819Q204 841 219 856T257 872Q278 872 293 857T309 819Q309 797 294 782T257 767Q235 767 220 782ZM397 767T382 782T367 819Q367 841 382 856T419 872Q441 872 456 857T472 819Q472 797 457 782T419 767Q397 767 382 782Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    glyphName: "Yacute",
    horizAdvX: 584,
    d: "M565 697L338 263V0H247V263L19 697H120L292 344L464 697H565ZM390 848L177 734V802L390 927V848Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    glyphName: "Thorn",
    horizAdvX: 579,
    d: "M543 261T484 204T302 146H168V0H77V698H168V553H302Q420 553 481 496T543 349Q543 261 484 204ZM377 219T413 253T450 349Q450 411 414 446T302 481H168V219H302Q377 219 413 253Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    glyphName: "germandbls",
    horizAdvX: 681,
    d: "M60 654T119 712T295 771Q364 771 413 748T488 687T514 605Q514 557 490 524T424 455Q397 432 385 418T373 387Q373 365 396 349T484 311Q557 287 590 249T623 151Q623 79 573 35T433 -10Q346 -10 291 38T229 170H321Q324 121 353 92T433 63Q480 63 505 84T530 144Q530 180 508 202T431 242Q350 269 316 299T281 375Q281 410 300 436T356 495Q390 526 406 548T423 598Q423 643 389 668T294 694Q151 694 151 550V0H60V561Q60 654 119 712Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    glyphName: "agrave",
    horizAdvX: 676,
    d: "M43 360T77 423T170 522T303 557Q375 557 428 526T507 448V548H599V0H507V102Q480 54 427 23T302 -9Q229 -9 170 27T77 128T43 276Q43 360 77 423ZM507 337T482 383T415 453T321 478Q270 478 228 454T161 384T136 276Q136 213 161 167T228 96T321 71Q372 71 414 95T482 166T507 275Q507 337 482 383ZM436 657V589L223 703V782L436 657Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    glyphName: "aacute",
    horizAdvX: 676,
    d: "M43 360T77 423T170 522T303 557Q375 557 428 526T507 448V548H599V0H507V102Q480 54 427 23T302 -9Q229 -9 170 27T77 128T43 276Q43 360 77 423ZM507 337T482 383T415 453T321 478Q270 478 228 454T161 384T136 276Q136 213 161 167T228 96T321 71Q372 71 414 95T482 166T507 275Q507 337 482 383ZM436 703L223 589V657L436 782V703Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    glyphName: "acircumflex",
    horizAdvX: 676,
    d: "M43 360T77 423T170 522T303 557Q375 557 428 526T507 448V548H599V0H507V102Q480 54 427 23T302 -9Q229 -9 170 27T77 128T43 276Q43 360 77 423ZM507 337T482 383T415 453T321 478Q270 478 228 454T161 384T136 276Q136 213 161 167T228 96T321 71Q372 71 414 95T482 166T507 275Q507 337 482 383ZM339 682L200 597V669L339 752L477 669V597L339 682Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    glyphName: "atilde",
    horizAdvX: 676,
    d: "M43 360T77 423T170 522T303 557Q375 557 428 526T507 448V548H599V0H507V102Q480 54 427 23T302 -9Q229 -9 170 27T77 128T43 276Q43 360 77 423ZM507 337T482 383T415 453T321 478Q270 478 228 454T161 384T136 276Q136 213 161 167T228 96T321 71Q372 71 414 95T482 166T507 275Q507 337 482 383ZM199 658T225 685T292 712Q311 712 324 706T357 687Q371 677 382 672T406 666Q423 666 435 677T450 709H502Q496 659 469 632T402 605Q383 605 369 611T336 631Q320 641 311 646T288 651Q271 651 260 640T245 607H192Q199 658 225 685Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    glyphName: "adieresis",
    horizAdvX: 676,
    d: "M43 360T77 423T170 522T303 557Q375 557 428 526T507 448V548H599V0H507V102Q480 54 427 23T302 -9Q229 -9 170 27T77 128T43 276Q43 360 77 423ZM507 337T482 383T415 453T321 478Q270 478 228 454T161 384T136 276Q136 213 161 167T228 96T321 71Q372 71 414 95T482 166T507 275Q507 337 482 383ZM236 622T221 637T205 674Q205 696 220 711T258 727Q279 727 294 712T310 674Q310 652 295 637T258 622Q236 622 221 637ZM398 622T383 637T368 674Q368 696 383 711T420 727Q442 727 457 712T473 674Q473 652 458 637T420 622Q398 622 383 637Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    glyphName: "aring",
    horizAdvX: 676,
    d: "M43 360T77 423T170 522T303 557Q375 557 428 526T507 448V548H599V0H507V102Q480 54 427 23T302 -9Q229 -9 170 27T77 128T43 276Q43 360 77 423ZM507 337T482 383T415 453T321 478Q270 478 228 454T161 384T136 276Q136 213 161 167T228 96T321 71Q372 71 414 95T482 166T507 275Q507 337 482 383ZM446 664T416 636T339 607Q294 607 263 636T232 712Q232 759 263 788T339 817Q385 817 415 789T446 712Q446 664 416 636ZM393 738T378 753T339 769Q316 769 301 754T285 713Q285 688 300 672T339 656Q362 656 377 672T393 713Q393 738 378 753Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    glyphName: "ae",
    horizAdvX: 1097,
    d: "M1055 268T1051 243H600Q605 187 632 148T699 88T783 68Q847 68 889 95T945 169H1043Q1021 90 957 41T798 -9Q731 -9 675 22T589 106V0H510V105Q480 54 426 23T303 -9Q230 -9 171 27T77 128T43 276Q43 360 77 423T172 522T308 557Q375 557 427 529T513 447V548H589V447Q660 557 798 557Q874 557 932 523T1023 429T1055 297Q1055 268 1051 243ZM961 362T938 400T874 459T784 480Q712 480 660 434T600 309H961Q961 362 938 400ZM372 71T414 95T482 166T507 275Q507 337 482 383T415 453T321 478Q270 478 228 454T161 384T136 276Q136 213 161 167T228 96T321 71Q372 71 414 95Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    glyphName: "ccedilla",
    horizAdvX: 607,
    d: "M370 68T410 96T465 176H563Q543 98 485 49T338 -8V-58Q397 -57 432 -83T467 -157Q467 -204 433 -232T345 -260H230V-201H327Q360 -201 375 -191T391 -157Q391 -134 376 -124T327 -114H277V-7Q208 0 155 36T73 134T43 275Q43 360 77 423T171 522T310 557Q411 557 476 508T563 372H465Q451 422 411 451T310 480Q232 480 184 427T136 275Q136 176 184 122T310 68Q370 68 410 96Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    glyphName: "egrave",
    horizAdvX: 620,
    d: "M577 269T574 240H136Q141 159 191 114T314 68Q373 68 412 95T468 169H566Q544 90 478 41T314 -9Q236 -9 175 26T78 125T43 275Q43 360 77 424T172 522T314 557Q392 557 452 523T544 430T577 295Q577 269 574 240ZM483 366T460 403T398 460T310 480Q241 480 193 436T137 314H483Q483 366 460 403ZM408 657V589L195 703V782L408 657Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    glyphName: "eacute",
    horizAdvX: 620,
    d: "M577 269T574 240H136Q141 159 191 114T314 68Q373 68 412 95T468 169H566Q544 90 478 41T314 -9Q236 -9 175 26T78 125T43 275Q43 360 77 424T172 522T314 557Q392 557 452 523T544 430T577 295Q577 269 574 240ZM483 366T460 403T398 460T310 480Q241 480 193 436T137 314H483Q483 366 460 403ZM408 703L195 589V657L408 782V703Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    glyphName: "ecircumflex",
    horizAdvX: 620,
    d: "M577 269T574 240H136Q141 159 191 114T314 68Q373 68 412 95T468 169H566Q544 90 478 41T314 -9Q236 -9 175 26T78 125T43 275Q43 360 77 424T172 522T314 557Q392 557 452 523T544 430T577 295Q577 269 574 240ZM483 366T460 403T398 460T310 480Q241 480 193 436T137 314H483Q483 366 460 403ZM311 682L172 597V669L311 752L449 669V597L311 682Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    glyphName: "edieresis",
    horizAdvX: 620,
    d: "M577 269T574 240H136Q141 159 191 114T314 68Q373 68 412 95T468 169H566Q544 90 478 41T314 -9Q236 -9 175 26T78 125T43 275Q43 360 77 424T172 522T314 557Q392 557 452 523T544 430T577 295Q577 269 574 240ZM483 366T460 403T398 460T310 480Q241 480 193 436T137 314H483Q483 366 460 403ZM207 622T192 637T176 674Q176 696 191 711T229 727Q250 727 265 712T281 674Q281 652 266 637T229 622Q207 622 192 637ZM369 622T354 637T339 674Q339 696 354 711T391 727Q413 727 428 712T444 674Q444 652 429 637T391 622Q369 622 354 637Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    glyphName: "igrave",
    horizAdvX: 246,
    d: "M168 548V0H77V548H168ZM476 657V589L263 703V782L476 657Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    glyphName: "iacute",
    horizAdvX: 246,
    d: "M168 548V0H77V548H168ZM476 703L263 589V657L476 782V703Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    glyphName: "icircumflex",
    horizAdvX: 246,
    d: "M168 548V0H77V548H168ZM379 682L240 597V669L379 752L517 669V597L379 682Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    glyphName: "idieresis",
    horizAdvX: 246,
    d: "M168 548V0H77V548H168ZM276 622T261 637T245 674Q245 696 260 711T298 727Q319 727 334 712T350 674Q350 652 335 637T298 622Q276 622 261 637ZM438 622T423 637T408 674Q408 696 423 711T460 727Q482 727 497 712T513 674Q513 652 498 637T460 622Q438 622 423 637Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    glyphName: "eth",
    horizAdvX: 638,
    d: "M596 507T596 315Q596 210 560 138T461 28T316 -9Q237 -9 175 26T78 127T43 278Q43 361 78 424T174 523T311 558Q430 558 492 466Q460 561 391 638L261 594V644L355 676Q323 707 282 740H375Q415 705 421 699L552 743V692L458 660Q596 507 596 315ZM366 68T408 92T476 163T502 275Q502 340 477 387T410 457T318 481Q268 481 227 458T161 389T136 278Q136 212 160 165T225 93T316 68Q366 68 408 92Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    glyphName: "ntilde",
    horizAdvX: 640,
    d: "M444 558T506 498T568 323V0H478V310Q478 392 437 435T325 479Q253 479 211 434T168 303V0H77V548H168V470Q195 512 241 535T344 558Q444 558 506 498ZM182 658T208 685T275 712Q294 712 307 706T340 687Q354 677 365 672T389 666Q406 666 418 677T433 709H485Q479 659 452 632T385 605Q366 605 352 611T319 631Q303 641 294 646T271 651Q254 651 243 640T228 607H175Q182 658 208 685Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    glyphName: "ograve",
    horizAdvX: 640,
    d: "M239 -9T177 26T79 125T43 275Q43 359 79 423T179 522T320 557Q398 557 461 523T560 424T597 275Q597 190 560 126T458 26T316 -9Q239 -9 177 26ZM365 71T408 94T477 163T504 275Q504 341 478 387T410 455T319 478Q269 478 228 456T161 387T136 275Q136 208 160 162T226 94T316 71Q365 71 408 94ZM418 664V596L205 710V789L418 664Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    glyphName: "oacute",
    horizAdvX: 640,
    d: "M239 -9T177 26T79 125T43 275Q43 359 79 423T179 522T320 557Q398 557 461 523T560 424T597 275Q597 190 560 126T458 26T316 -9Q239 -9 177 26ZM365 71T408 94T477 163T504 275Q504 341 478 387T410 455T319 478Q269 478 228 456T161 387T136 275Q136 208 160 162T226 94T316 71Q365 71 408 94ZM418 710L205 596V664L418 789V710Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    glyphName: "ocircumflex",
    horizAdvX: 640,
    d: "M239 -9T177 26T79 125T43 275Q43 359 79 423T179 522T320 557Q398 557 461 523T560 424T597 275Q597 190 560 126T458 26T316 -9Q239 -9 177 26ZM365 71T408 94T477 163T504 275Q504 341 478 387T410 455T319 478Q269 478 228 456T161 387T136 275Q136 208 160 162T226 94T316 71Q365 71 408 94ZM321 689L182 604V676L321 759L459 676V604L321 689Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    glyphName: "otilde",
    horizAdvX: 640,
    d: "M239 -9T177 26T79 125T43 275Q43 359 79 423T179 522T320 557Q398 557 461 523T560 424T597 275Q597 190 560 126T458 26T316 -9Q239 -9 177 26ZM365 71T408 94T477 163T504 275Q504 341 478 387T410 455T319 478Q269 478 228 456T161 387T136 275Q136 208 160 162T226 94T316 71Q365 71 408 94ZM181 665T207 692T274 719Q293 719 306 713T339 694Q353 684 364 679T388 673Q405 673 417 684T432 716H484Q478 666 451 639T384 612Q365 612 351 618T318 638Q302 648 293 653T270 658Q253 658 242 647T227 614H174Q181 665 207 692Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    glyphName: "odieresis",
    horizAdvX: 640,
    d: "M239 -9T177 26T79 125T43 275Q43 359 79 423T179 522T320 557Q398 557 461 523T560 424T597 275Q597 190 560 126T458 26T316 -9Q239 -9 177 26ZM365 71T408 94T477 163T504 275Q504 341 478 387T410 455T319 478Q269 478 228 456T161 387T136 275Q136 208 160 162T226 94T316 71Q365 71 408 94ZM218 629T203 644T187 681Q187 703 202 718T240 734Q261 734 276 719T292 681Q292 659 277 644T240 629Q218 629 203 644ZM380 629T365 644T350 681Q350 703 365 718T402 734Q424 734 439 719T455 681Q455 659 440 644T402 629Q380 629 365 644Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    glyphName: "divide",
    horizAdvX: 657,
    d: "M309 520T291 538T273 582Q273 608 291 626T335 644Q360 644 377 626T395 582Q395 556 378 538T335 520Q309 520 291 538ZM588 405V328H78V405H588ZM309 91T291 109T273 153Q273 179 291 197T335 215Q360 215 377 197T395 153Q395 127 378 109T335 91Q309 91 291 109Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    glyphName: "oslash",
    horizAdvX: 640,
    d: "M530 468Q562 431 579 382T597 275Q597 190 560 126T458 26T316 -9Q219 -9 145 46L103 0H38L110 79Q78 117 61 166T43 275Q43 359 79 423T179 522T320 557Q421 557 495 500L538 548H603L530 468ZM136 198T171 145L437 437Q389 478 319 478Q269 478 228 456T161 387T136 275Q136 198 171 145ZM504 352T469 401L203 109Q250 71 316 71Q365 71 408 94T477 163T504 275Q504 352 469 401Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    glyphName: "ugrave",
    horizAdvX: 640,
    d: "M563 548V0H472V81Q446 39 400 16T297 -8Q233 -8 182 18T102 98T72 227V548H162V239Q162 158 203 115T315 71Q388 71 430 116T472 247V548H563ZM418 657V589L205 703V782L418 657Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    glyphName: "uacute",
    horizAdvX: 640,
    d: "M563 548V0H472V81Q446 39 400 16T297 -8Q233 -8 182 18T102 98T72 227V548H162V239Q162 158 203 115T315 71Q388 71 430 116T472 247V548H563ZM418 703L205 589V657L418 782V703Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    glyphName: "ucircumflex",
    horizAdvX: 640,
    d: "M563 548V0H472V81Q446 39 400 16T297 -8Q233 -8 182 18T102 98T72 227V548H162V239Q162 158 203 115T315 71Q388 71 430 116T472 247V548H563ZM321 682L182 597V669L321 752L459 669V597L321 682Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    glyphName: "udieresis",
    horizAdvX: 640,
    d: "M563 548V0H472V81Q446 39 400 16T297 -8Q233 -8 182 18T102 98T72 227V548H162V239Q162 158 203 115T315 71Q388 71 430 116T472 247V548H563ZM218 622T203 637T187 674Q187 696 202 711T240 727Q261 727 276 712T292 674Q292 652 277 637T240 622Q218 622 203 637ZM380 622T365 637T350 674Q350 696 365 711T402 727Q424 727 439 712T455 674Q455 652 440 637T402 622Q380 622 365 637Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    glyphName: "yacute",
    horizAdvX: 563,
    d: "M549 548L219 -258H125L233 6L12 548H113L285 104L455 548H549ZM379 703L166 589V657L379 782V703Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    glyphName: "thorn",
    horizAdvX: 676,
    d: "M194 488T247 522T373 557Q446 557 505 522T599 424T633 276Q633 193 599 128T506 27T373 -9Q301 -9 248 26T168 120V-260H77V740H168V432Q194 488 247 522ZM540 338T515 384T448 454T354 478Q304 478 262 454T194 383T168 275Q168 213 193 167T261 96T354 71Q405 71 447 95T515 166T540 276Q540 338 515 384Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    glyphName: "ydieresis",
    horizAdvX: 563,
    d: "M549 548L219 -258H125L233 6L12 548H113L285 104L455 548H549ZM179 622T164 637T148 674Q148 696 163 711T201 727Q222 727 237 712T253 674Q253 652 238 637T201 622Q179 622 164 637ZM341 622T326 637T311 674Q311 696 326 711T363 727Q385 727 400 712T416 674Q416 652 401 637T363 622Q341 622 326 637Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    glyphName: "endash",
    horizAdvX: 677,
    d: "M602 405V328H76V405H602Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    glyphName: "emdash",
    horizAdvX: 885,
    d: "M809 405V328H76V405H809Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    glyphName: "quoteleft",
    horizAdvX: 219,
    d: "M126 470H24L120 697H185L126 470Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    glyphName: "quoteright",
    horizAdvX: 219,
    d: "M91 697H192L96 470H32L91 697Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    glyphName: "quotesinglbase",
    horizAdvX: 186,
    d: "M58 115H159L63 -112H-2L58 115Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    glyphName: "quotedblleft",
    horizAdvX: 380,
    d: "M126 470H24L120 697H185L126 470ZM288 470H186L282 697H347L288 470Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    glyphName: "quotedblright",
    horizAdvX: 380,
    d: "M91 697H192L96 470H32L91 697ZM253 697H354L258 470H193L253 697Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    glyphName: "quotedblbase",
    horizAdvX: 350,
    d: "M57 115H159L63 -112H-2L57 115ZM222 115H323L227 -112H162L222 115Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    glyphName: "bullet",
    horizAdvX: 412,
    d: "M154 211T119 246T83 333Q83 385 118 420T205 456Q257 456 293 421T329 333Q329 282 293 247T205 211Q154 211 119 246Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    glyphName: "guilsinglleft",
    horizAdvX: 280,
    d: "M141 120L45 295L141 470H230L131 295L230 120H141Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    glyphName: "guilsinglright",
    horizAdvX: 280,
    d: "M149 295L50 470H139L235 295L139 120H50L149 295Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoppinsV19LatinRegular);
export default __webpack_public_path__ + "static/media/poppins-v19-latin-regular.04277a799cb3f1b29dfad816139bad03.svg";
export { ForwardRef as ReactComponent };